"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarIcon = exports.ToolbarItemType = void 0;
var ToolbarItemType;

(function (ToolbarItemType) {
  ToolbarItemType[ToolbarItemType["SELECTOR"] = 0] = "SELECTOR";
  ToolbarItemType[ToolbarItemType["SWITCH"] = 1] = "SWITCH";
  ToolbarItemType[ToolbarItemType["SEPARATOR"] = 2] = "SEPARATOR";
  ToolbarItemType[ToolbarItemType["TRIGGER"] = 3] = "TRIGGER";
})(ToolbarItemType = exports.ToolbarItemType || (exports.ToolbarItemType = {}));

var ToolbarIcon = /*#__PURE__*/function () {
  function ToolbarIcon(paper, icon) {
    _classCallCheck(this, ToolbarIcon);

    this.isSelected = false;
    this.paper = paper;

    if (icon !== undefined && icon !== null) {
      this.description = icon;

      if (icon.width !== undefined) {
        this.width = icon.width;
      } else {
        this.width = ToolbarIcon.IconWidth;
      }

      if (icon.height !== undefined) {
        this.height = icon.height;
      } else {
        this.height = ToolbarIcon.IconHeight;
      }
    } else {
      this.description = null;
      this.width = ToolbarIcon.IconWidth;
      this.height = ToolbarIcon.IconHeight;
    }
  }

  _createClass(ToolbarIcon, [{
    key: "move",
    value: function move(x, y) {
      this.x = x;
      this.y = y;
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      this.width = width;
      this.height = height;
    }
  }, {
    key: "select",
    value: function select() {
      this.node.addClass("selected");
      this.isSelected = true;
    }
  }, {
    key: "unselect",
    value: function unselect() {
      this.node.removeClass("selected");
      this.isSelected = false;
    }
  }, {
    key: "toggleSelection",
    value: function toggleSelection() {
      if (this.isSelected) {
        this.unselect();
      } else {
        this.select();
      }
    }
  }]);

  return ToolbarIcon;
}();

exports.ToolbarIcon = ToolbarIcon;
ToolbarIcon.IconWidth = 48;
ToolbarIcon.IconHeight = 48;